import script from "./ProductSideTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSideTemplate.vue?vue&type=script&setup=true&lang=js"

import "./ProductSideTemplate.vue?vue&type=style&index=0&id=7d6462f0&lang=scss&scoped=true"

import exportComponent from "F:\\ubuntuBK\\sombardc\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d6462f0"]])

export default __exports__